import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Lock, Loader2 } from "lucide-react";
import { Input } from "../ui/input";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AdminLogin = ({ onLogin }) => {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!password) return;
    setLoading(true);
    try {
      await axios.post(`${API}/admin/login`, { password });
      onLogin();
      toast.success("Welcome back!");
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm bg-[#121212] border border-zinc-800 rounded-xl p-8">
        <div className="bg-blue-600/10 border border-blue-500/20 rounded-sm w-12 h-12 flex items-center justify-center mb-5 mx-auto">
          <Lock className="h-5 w-5 text-blue-500" />
        </div>
        <h1 className="font-heading text-2xl font-bold text-white text-center mb-1">Admin Access</h1>
        <p className="text-zinc-500 text-sm text-center mb-6">Enter the admin password to view leads.</p>
        <Input
          data-testid="admin-password-input"
          type="password"
          autoFocus
          className="bg-[#0a0a0a] border-zinc-800 text-white h-11 rounded-sm mb-4"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button
          data-testid="admin-login-button"
          type="submit"
          disabled={loading}
          className="w-full inline-flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 disabled:opacity-60 text-white rounded-sm px-6 py-3 font-semibold transition-colors"
        >
          {loading && <Loader2 className="h-4 w-4 animate-spin" />}
          {loading ? "Signing in..." : "Sign In"}
        </button>
      </form>
    </div>
  );
};
